<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Batch Lelang</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA LELANG</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Cabang</b-col>
                    <b-col>
                        {{dataBatch.cabang}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jumlah Unit</b-col>
                    <b-col>
                        {{dataBatch.jumlahUnit}} 
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jumlah Approved</b-col>
                    <b-col>
                        {{dataBatch.jumlahApproved}} 
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jumlah Hilang</b-col>
                    <b-col>
                        {{dataBatch.jumlahHilang}} 
                    </b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA BARANG</h6>
                <div class="d-flex search-wrapper align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >
                        <div class="d-flex align-items-center search-input-wrapper">
                            <b-form-input class="ml-2 mr-2"
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                id="filterInput"
                                type="search"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                            <multiselect class="mr-2" name="jenisBarang"
                                :value="optionJenisBarang.find(item => item.id == input.filterJenisBarang) || null"
                                :options="optionJenisBarang" :internal-search="true" :allow-empty="true"
                                deselect-label="" select-label="" label="name" track-by="id"
                                placeholder="Jenis Barang"
                                @input="input.filterJenisBarang = $event ? $event.id : null" />
                            <b-form-select class="mr-2" v-model="input.filterStatus" name="jenisBarang" :options="statusOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                </template>
                            </b-form-select>
                            <!-- <b-form-checkbox class="mr-5" v-model="input.filterHilangOnly" name="filterHilangOnly"
                            >
                                Hilang Only
                            </b-form-checkbox> -->
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy" 
                    :items="dataBatchLelangItems" 
                    :fields="fields"
                    :no-local-sorting="false"
                    @sort-changed="sortingChanged" 
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada item untuk dicek.
                    </template>
                    <template v-slot:cell(hargaBarang)="row">
                        <div class="text-right no-wrap" v-if="row.item.hargaBarang !== null">Rp. {{$helper.addThousandSeparator(row.item.hargaBarang)}} </div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.hargaBarang)}} </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="warning" v-if="row.item.status == 'ORDER'">ORDER</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status == 'HILANG'">HILANG</b-badge>
                        <b-badge variant="dark" v-else-if="row.item.status == 'PENGIRIMAN'">PENGIRIMAN</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status == 'DITERIMA'">DITERIMA</b-badge>
                        <b-badge variant="warning" v-else-if="row.item.status == 'KIRIM BALIK'">KIRIM BALIK</b-badge>
                        <b-badge variant="primary" v-else>TERJUAL</b-badge>
                    </template>
                    <template v-slot:head(status)>
                        Status 
                        <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">ORDER</h6>
                <p class="smallText mb-0">Barang ini masih dalam persiapan untuk dilelangkan. Posisi barang masih di cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">HILANG</h6>
                <p class="smallText mb-0">Barang dinyatakan hilang / tidak ditemukan oleh pihak pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENGIRIMAN</h6>
                <p class="smallText mb-0">Barang dalam pengiriman menuju pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Barang sudah diterima oleh pihak pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">KIRIM BALIK</h6>
                <p class="smallText mb-0">Barang dalam pengiriman kembali dari pelelangan ke cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">TERJUAL</h6>
                <p class="smallText mb-0">Barang sudah terjual.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'detail-batch-lelang',
    data(){
        return{
            id: null,
            isBusy: true,
            initStatus: 1,
            input:{
                show: 10,
                filterNoFaktur: null,
                filterJenisBarang: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur" },
                { key: "jenis.name", label: "Jenis Barang" },
                { key: "merk.name", label: "Merk Barang" },
                { key: "tipe.name", label: "Tipe Barang" },
                { key: "imeiSn", label: "No. IMEI / SN" },
                { key: "hargaBarang", label: "Harga Barang" },
                { key: "status", label: "Status" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [
                { id: 0, name: 'Order' },
                { id: 1, name: 'Hilang' },
                { id: 2, name: 'Pengiriman' },
                { id: 3, name: 'Diterima' },
                { id: 4, name: 'Kirim Balik' },
                { id: 5, name: 'Terjual' }
            ],
            dataBatch: {},
            dataBatchLelangItems: [],
            optionJenisBarang: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            filtering: false,
            query: ""
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            
            this.id = this.$route.params.idBatch
            
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.query = this.query+"&batchId="+this.id
            
            let getJenisElek = this.$axios.get("barang-jenis/elektronik-emas").then(response => {
                this.optionJenisBarang = response.data
            })

            let getSingleDataBatch = this.$axios.get(`lelang-order/batch/${this.id}`).then(response => {
                this.dataBatch = response.data
                this.toggleBusy()
               
            })
            
            let getBatchLelangItems= this.$axios.get(`lelang-order/item/${this.query}`).then(response => {
                this.dataBatchLelangItems = response.data.data
           
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getJenisElek, getSingleDataBatch, getBatchLelangItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Fungsi Ambil Data Cek Items -----------------

        getBatchLelangItems(){
            if (this.isBusy == false) this.isBusy = true
            this.page = this.currentPage-1
            this.dataBatchLelangItems = []

            if (this.filtering == false) {
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.query = this.query+"&batchId="+this.id
            }else{
                this.query = this.query+"&batchId="+this.id
            }
            
            this.$axios.get(`lelang-order/item/${this.query}`).then(response => {
                this.dataBatchLelangItems = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.filtering = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.filtering = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------
        
        onLimitChange(){
            this.toggleBusy()
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.getBatchLelangItems()
        },

        onPageChange(){
            if (this.filtering == false) {
                this.toggleBusy()
                this.getBatchLelangItems()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.currentPage = 1
                this.getBatchLelangItems()
            }
        },

        onReset(){
            this.input.filterNoFaktur = null
            this.input.filterJenisBarang = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.toggleBusy()
            this.getBatchLelangItems()
        },

        onFilter(){
            this.toggleBusy()
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            
            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterJenisBarang != null) this.query = this.query + "&filterJenis=" + this.input.filterJenisBarang
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.filtering = true
            this.getBatchLelangItems()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

    },

    created(){
        this.init()
    }
}
</script>
